// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay-scrollbar{height:100%}", "",{"version":3,"sources":["webpack://src/components/TypicalOverlayScrollbar/typicalOverlayScrollbar.scss"],"names":[],"mappings":"AAAA,mBACC,WAAA","sourcesContent":[".overlay-scrollbar {\n\theight: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
